/**
 * @generated SignedSource<<9fecc09821c62d14ee895985eb12349b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type AddAccountToCartInput = {
  accountNumber: string;
  cartId: string;
  channel: CartChannel;
};
export type useUpdateCartAccountMutation$variables = {
  input: AddAccountToCartInput;
};
export type useUpdateCartAccountMutation$data = {
  readonly addAccountToCart: {
    readonly message: string;
    readonly code: number;
    readonly success: boolean;
  };
};
export type useUpdateCartAccountMutation = {
  variables: useUpdateCartAccountMutation$variables;
  response: useUpdateCartAccountMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAccountToCartResponse",
    "kind": "LinkedField",
    "name": "addAccountToCart",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateCartAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateCartAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ace1bcae0303701a33d53a69ffa0746f",
    "id": null,
    "metadata": {},
    "name": "useUpdateCartAccountMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCartAccountMutation(\n  $input: AddAccountToCartInput!\n) {\n  addAccountToCart(input: $input) {\n    message\n    code\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e8bf3bb632d2191f83956d5c125d207";

export default node;
